import { observable, action, makeObservable } from 'mobx';
import { BaseStore } from './BaseStore';
import { NotificationType } from 'interfaces/template/INotification';
import { ILocationFinderResponse, IItem } from 'interfaces/locationfinder/ILocationFinderResponse';
import type { AxiosInstance } from 'axios';
import { NotificationsStore } from './NotificationsStore';
import { LocationFinderApiService } from './LocationFinderApiService';

export class LocationStore extends BaseStore {
  ipResponse: string = '';
  isLocationResponseLoading: boolean = true;
  isIpResponseLoading: boolean = true;
  locationResponse = {} as ILocationFinderResponse;

  private _locationFinderService: LocationFinderApiService;
  private _notificationStore: NotificationsStore;
  constructor(locationFinderService: LocationFinderApiService, notificationStore: NotificationsStore) {
    super();
    this._locationFinderService = locationFinderService;
    this._notificationStore = notificationStore;

    makeObservable(this, {
      ipResponse: observable,
      isLocationResponseLoading: observable,
      isIpResponseLoading: observable,
      locationResponse: observable,
      setLocation: action,
      setIp: action,
      fetchLocations: action,
      fetchIp: action,
    });
  }

  setLocation = (data: ILocationFinderResponse) => {
    this.isLocationResponseLoading = false;
    this.locationResponse = data;
  };

  setIp = (ip: string) => {
    this.isIpResponseLoading = false;
    this.ipResponse = ip;
  };

  fetchLocations = async (apiInstance: AxiosInstance) => {
    try {
      this.isLocationResponseLoading = true;
      await this.fetchData(
        () => this._locationFinderService.getLocations(apiInstance),

        this.setLocation
      );
      // this._notificationStore.addToast('Success', 'Success', NotificationType.success);
    } catch (ex) {
      this._notificationStore.addToast('Error', 'Error', NotificationType.error);
    }
  };

  fetchIp = async (apiInstance: AxiosInstance) => {
    try {
      this.isIpResponseLoading = true;

      await this.fetchData(() => this._locationFinderService.getIp(apiInstance), this.setIp);
      // this._notificationStore.addToast('Success', 'Success', NotificationType.success);
    } catch (ex) {
      this._notificationStore.addToast('Error', 'Error', NotificationType.error);
    }
  };
}
